import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button, Form, Table, Modal, Select } from 'antd'
import { Queries, Mutations } from '../../../../../graphql'
import ModalForm1 from './modalForm1'
import ModalForm2 from './modalForm2'
import moment from 'moment'
import { changeFormatFullDateTime, changeFormatdate, changeFormatdateDayMonth } from '../../../../../utils/formatdate'
import { convertToHTMl } from '../../../../../utils/markDown'
import ModalConfirmForm from '../../../../../components/user/ModalConfirmForm'
import { alertMessage } from '../../../../../utils/message'
import { numberWithCommas } from '../../../../../utils/number'
import { checkStatusSessionHistory, checkRequestTypeSessionHistory, TextMessagesDetailHistory } from '../../../../../utils/fund'
import {
    BrowserRouter as Router,
    Link,
    Route
} from 'react-router-dom'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

const formItemLayout = {
	labelCol: {
	  xs: { span: 24 },
	  sm: { span: 8 },
	},
	wrapperCol: {
	  xs: { span: 24 },
	  sm: { span:16 },
	},
  };


class condition1 extends Component {
	state = {
		dataTableChangProvidentFund:[],
        columnsProvidentFund:[
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ changeFormatFullDateTime(item)}</span>
            },
            {
                title: 'ชื่อผู้แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ '-' }</span>
            },
            {
                title: 'อัตราหักเงินสะสมทบ',
                dataIndex: 'provEmployerDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{item.toFixed(2)}</span>
            },
            {
                title: 'อัตราหักเงินสะสม',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{item.toFixed(2)}</span>
            },
            {
                title: 'นโยบายการลงทุน',
                dataIndex: 'providentFundName',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item ? item : '-' }</span>
            },
            {
                title: 'หมายเหตุ',
                dataIndex: 'providentFundName',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNode(item)}} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            > 
                                อ่านหมายเหตุ
                            </span>
                        : '-'
                    }
                
                </>
            },
           
        ],
        dataTableChangPeopleFund:[],
        columnsPeopleFund:[
            {
                title: 'คนที่',
                dataIndex: 'listNo',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'ชื่อ - นามสกุล',
                dataIndex: 'benefitsName',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <div align={"left"}>{ item }</div>
            },
            {
                title: 'เลขที่บัตรประชาชน',
                dataIndex: 'benefitsIdCard',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item ? item : '-' }</span>
            },
            {
                title: 'เปอร์เซ็นต์ที่ได้รับ',
                dataIndex: 'benefitsRate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item.toFixed(2) }</span>
            }
        ],
        modalCondition1: false,
        modalCondition2: false,
        configDataProvPercentage: null,
        showModalNote: false,
        noteModal: null,
        titleNoteModal: "หมายเหตุ",
        dataTableSessionHistory:[],
        columnsSessionHistory:[
            {
                title: 'ประเภทการแก้ไข',
                dataIndex: 'requestType',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ checkRequestTypeSessionHistory(item) }</span>
            },
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'updatedAt',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ changeFormatFullDateTime(item)}</span>
            },
            {
                title: 'วันที่ส่งไป HRMI',
                dataIndex: 'syncDate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ item ? changeFormatFullDateTime(item) : '-' }</span>
            },
            {
                title: 'สถานะ',
                dataIndex: 'status',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => this.showHistoryRescord(record)
            },
            {
                title: 'ผู้ดำเนินการ',
                dataIndex: 'updatedBy',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <div align={"left"}>
                                                        {/* { this.props.profile.title+' '+this.props.profile.firstName+' '+this.props.profile.lastName } */}
                                                        { item }
                                                    </div>
            },
			{
                title: 'รายละเอียด',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => this.showTextMessages(record)
            },
           
        ],
        noteModalSession: null,
        statusForm: false,
        ModalConfirmFormSubTitle:null,
        ModalConfirmFormShowModal:false,
        ModalConfirmFormBtnOk:null,
        ModalConfirmFormBtnCancel:null,
        ModalConfirmFormValue:null,
        ModalConfirmFormStatus:null,
		ModalConfirmFormMessage:null,
        showModalNoteSession: false,
	}

    showTextMessages = (record) =>{
        const { providentFundRateHistoryIsActiveBtn } = this.props
        if(record.requestType == 'RATE'){
            return <span 
                        onClick={()=>{this.showModalNodeSession(record)}} 
                        style={{ cursor:"pointer" }}
                        className="btn-show-fileuploads"
                    > 
                        { TextMessagesDetailHistory(record.status, providentFundRateHistoryIsActiveBtn) }
                    </span>
        }else{
            return  <Link
                            to={{
                                pathname: 'benefitsPerson/'+record.fundRequestId,
                            }}
                        >
                        <span 
                            style={{ cursor:"pointer" }}
                            className="btn-show-fileuploads"
                        > 
                            { TextMessagesDetailHistory(record.status, providentFundRateHistoryIsActiveBtn) }
                        </span>
                    </Link>
        }
    }

    showHistoryRescord = (record) => {
        const { providentFundRateHistoryIsActiveBtn } = this.props
            return <span> 
                        { checkStatusSessionHistory(record.status, providentFundRateHistoryIsActiveBtn, record.requestType) }
                    </span>
    }

    showModalNodeSession = async (record) => {
        const { configDataProvPercentage } = this.state
        // let noteModal = ''
        record.summarySalary = ( parseFloat(record.fundChangeDetail.salary) * record.fundChangeDetail.provEmployeeDeduct) / 100
        
        await this.setState({
            showModalNoteSession: true,
            noteModalSession: record,
            // titleNoteModal: "รายละเอียด"
        });
    };


    showModalNode = async (item) => {
        await this.setState({
            showModalNote: true,
            noteModal:item,
            // titleNoteModal: "หมายเหตุ"
        });
    };

    showModalCondition1 = async () =>{
        const { configDataProvPercentage } = this.state

        if(configDataProvPercentage.isCanEdit ){
            await this.setState({
                modalCondition1: true
            })
        }else{
            alertMessage("warning","ไม่สามารถทำรายการได้ เนื่องจากมีเอกสารรอดำเนินการ")
        }
    }

    checkStatusprovidentFundBenefitsPerson = async () =>{
        const { dataForm } = this.props
        if(!dataForm.providentFundBenefitsPerson.isCanEdit ){
            alertMessage("warning","ไม่สามารถทำรายการได้ เนื่องจากมีเอกสารรอดำเนินการ")
        }
    }

    hideModalCondition1 = async () =>{
        await this.setState({
            modalCondition1: false
        })

        await this.fetchFundChangeHistory()
        await this.fetchConfigChangeProvPercentage()
    }

    hideModalCondition2 = async () =>{
        await this.setState({
            modalCondition2: false
        })
    }

    fetchConfigChangeProvPercentage = async () =>{
		const { client, location } = this.props

		const { data, errors } = await client.query({
			query: Queries.fetchConfigChangeProvPercentage,
		})

        if(data.fetchConfigChangeProvPercentage){
            await this.setState({
                configDataProvPercentage: data.fetchConfigChangeProvPercentage,
            })
        }
	}

    fetchFundChangeHistory = async () =>{
		const { client, location } = this.props

		const { data, errors } = await client.query({
			query: Queries.fetchFundChangeHistory,
		})

        if(data.fetchFundChangeHistory){
            await this.setState({
                dataTableSessionHistory: data.fetchFundChangeHistory
            })
        }
	}

    createFundApplication = async () =>{
        const { form, client, hideModalCondition1, fetchAllProvidentFundDetail } = this.props
		const { ModalConfirmFormValue, configDataProvPercentage } = this.state

		await this.setState({
			preLoadTable: true
		})

        try {

            const { data, errors } = await client.mutate({
                mutation: Mutations.createFundApplication,
            })

            if(data.createFundApplication.status){
                await fetchAllProvidentFundDetail()
                await this.hideModalConfirm()
                alertMessage("success","ส่งดำเนินการสำเร็จ")
            }
        }catch (error) {
            this.hideModalConfirm()
        }
    }


	updateFundRateChange = async () =>{
		const { form, client, hideModalCondition1 } = this.props
		const { ModalConfirmFormValue, configDataProvPercentage, statusForm, noteModalSession } = this.state

		await this.setState({
			preLoadTable: true
		})

		const { data, errors } = await client.mutate({
			mutation: Mutations.updateFundRateChange,
			variables: {
				provEmployeeDeduct : ModalConfirmFormValue.provEmployeeDeduct,
				fundRequestId: noteModalSession.fundRequestId,
				status: statusForm
			}
		})

		if(data.updateFundRateChange.status){
            if(statusForm == 'DRAFT'){
                alertMessage("success","บันทึกร่างสำเร็จ")
            }else if(statusForm == 'PENDING'){
                alertMessage("success","ส่งดำเนินการสำเร็จ")
            }else if(statusForm == 'CANCEL'){
			    alertMessage("success","ทำการยกเลิกการเปลี่ยนแปลงข้อมูลการหักเงินสะสมเรียบร้อย")
            }

            await this.hideModalConfirm()
			await this.fetchFundChangeHistory()
            await this.fetchConfigChangeProvPercentage()
            await this.setState({
                showModalNoteSession:false,
                statusForm: false
            })
		}
	}


    showModalConfirm = async (e) =>{
        const { form, client } = this.props
        const { statusForm } = this.state
        let ModalConfirmFormTitle = ''
       
        e.preventDefault()
		form.validateFields(async (err, values) => {
            if (!err) {
                if(statusForm == 'DRAFT'){
                    ModalConfirmFormTitle = 'ยืนยันการบันทึก'
                }else if(statusForm == 'PENDING'){
                    ModalConfirmFormTitle = 'ยืนยันการส่งดำเนินการปลี่ยนแปลงการหักเงินสะสม'
                }else if(statusForm == 'CANCEL'){
                    ModalConfirmFormTitle = 'ยกเลิกการปลี่ยนแปลงการหักเงินสะสม'
                }
    
                await this.setState({
                    ModalConfirmFormTitle,
                    ModalConfirmFormShowModal:true,
                    ModalConfirmFormBtnOk:"ตกลง",
                    ModalConfirmFormBtnCancel:'ยกเลิก',
                    ModalConfirmFormValue:values,
                    ModalConfirmFormStatus: null,
                    ModalConfirmFormMessage: null,
                    ModalFormTextArea: null,
                    ModalFormTextAreaRequie: null,
                    ModalSubmitToSend: this.updateFundRateChange
                })
			}else{
                this.setState({
                    preLoadOnsubmit: false
                })
            }
		})
    }

    showModalConfirmTisco = async () =>{
        await this.setState({
            ModalConfirmFormTitle:"ยืนยันการขอ User เพื่อเข้าใช้งาน Tisco",
            ModalConfirmFormShowModal:true,
            ModalConfirmFormBtnOk:"ตกลง",
            ModalConfirmFormBtnCancel:'ยกเลิก',
            ModalConfirmFormValue:[{}],
            ModalConfirmFormStatus: null,
            ModalConfirmFormMessage: null,
            ModalFormTextArea: null,
            ModalFormTextAreaRequie: null,
            ModalSubmitToSend: this.createFundApplication
        })
    }

    hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
            ModalConfirmFormMessage:null,
            preLoadOnsubmit: false
        })
    }

    renderDropDownMinMax = () =>{
		const { configDataProvPercentage } = this.state
		if(configDataProvPercentage){
			let optionArray = []
			for (var i=configDataProvPercentage.changeMin ; i <= configDataProvPercentage.changeMax; i++) {
				optionArray.push(<Option value={i}>{numberWithCommas(i)}</Option>)
			}

			return optionArray
		}
	}

    onChangeInputNumber = async (values) =>{
        const { noteModalSession } = this.state
        // let noteModal = ''
        noteModalSession.summarySalary = ( parseFloat(noteModalSession.fundChangeDetail.salary) * values) / 100
        
        await this.setState({
            noteModalSession,
        });
    }

    checkValueProvEmployeeDeduct = async (values) =>{

    }

	async componentDidMount(){
        await this.fetchConfigChangeProvPercentage()
        await this.fetchFundChangeHistory()
    }

	render() {
		const { dataForm, fundPolicyIsActiveBtn, providentFundRateHistoryIsActiveBtn, providentFundBenefitsPersonIsActiveBtn } = this.props
        const { getFieldDecorator } = this.props.form;
		const { 
                dataTableChangProvidentFund, 
                columnsProvidentFund, 
                columnsPeopleFund, 
                dataTableChangPeople,
                modalCondition1,
                modalCondition2,
                configDataProvPercentage,
                showModalNote,
                noteModal,
                ModalConfirmFormTitle,
                ModalConfirmFormSubTitle,
                ModalConfirmFormShowModal,
                ModalConfirmFormBtnOk,
                ModalConfirmFormBtnCancel,
                ModalConfirmFormValue,
                ModalFormTextArea,
                ModalFormTextAreaRequie,
                dataTableSessionHistory,
                columnsSessionHistory,
                showModalNoteSession,
                noteModalSession,
                ModalSubmitToSend
            } = this.state

            console.log('noteModalSession', noteModalSession)
		return (
			<div className="px-5 py-1 card-bg-green">
                
                <ModalConfirmForm 
					title={ModalConfirmFormTitle} 
					subtitle={ModalConfirmFormSubTitle}
					showModal={ModalConfirmFormShowModal} 
					btnOk={ModalConfirmFormBtnOk} 
					btnCancel={ModalConfirmFormBtnCancel}  
					submitToSend={ ModalSubmitToSend }
					hideModal={ this.hideModalConfirm }
					valueConfirm = { ModalConfirmFormValue }
					ModalFormTextArea = {ModalFormTextArea}
					ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
				/>
                
                <Modal
                    visible={showModalNoteSession}
                    destroyOnClose={true}
                    // visible={true}
                    title={"ดูรายละเอียด"}
                    width={800}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNoteSession:false,
                            statusForm: false
                        })
                    }}
                    footer={[]}
                >
                    {
                        noteModalSession &&
                        <Form {...formItemLayout} onSubmit={this.showModalConfirm}>
                            <Form.Item label="เงินเดือน" labelAlign="left" className="mb-1">
                                <Input className="w-50 mr-4" disabled={true} value={configDataProvPercentage ? numberWithCommas(configDataProvPercentage.salary) : ''}/>
                                <span className="ant-form-text">บาท</span>
                            </Form.Item>

                            <Form.Item label="หักเงินสะสมร้อยละ" labelAlign="left" className="mb-1">
                                {getFieldDecorator('provEmployeeDeduct', {
                                    initialValue: noteModalSession.fundChangeDetail.provEmployeeDeduct ? noteModalSession.fundChangeDetail.provEmployeeDeduct >= configDataProvPercentage.changeMin ? noteModalSession.fundChangeDetail.provEmployeeDeduct : numberWithCommas(noteModalSession.fundChangeDetail.provEmployeeDeduct) : '',
                                    // initialValue: this.checkValueProvEmployeeDeduct(noteModalSession.fundChangeDetail.provEmployeeDeduct),
                                    rules: [{ required: true, message: 'กรุณาระบุจำนวนหักเงินสะสมร้อยละ' }],
                                })(
                                    <Select 
                                        onChange={ (e) => this.onChangeInputNumber(e) } 
                                        className="w-50"
                                        disabled={ noteModalSession ? noteModalSession.status == 'DRAFT' ? 
                                        (noteModalSession.status == 'DRAFT' && providentFundRateHistoryIsActiveBtn === false) ? true : false : true : false }
                                    >
                                        { this.renderDropDownMinMax() }
                                        {/* <Option value="15">Jack</Option>
                                        <Option value="10">Lucy</Option> */}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label="การหักรายได้ต่อเดือน" labelAlign="left" className="mb-1">
                                <Input 
                                    className="w-50 mr-4" 
                                    disabled={true}
                                    value={noteModalSession ? numberWithCommas(noteModalSession.summarySalary) : ''}
                                />
                            </Form.Item>

                            <Row className="mt-3">
                                <Col>
                                    <strong>
                                        เงื่อนไข
                                    </strong>
                                    <ol>
                                        <li>
                                            สามารถเปลี่ยนแปลงการหักเงินสะสมได้ตั้งแต่วันที่ {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.provChangeDateFrom) : ''} ถึง  {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.provChangeDateTo) : ''} ของทุกปี
                                        </li>
                                        <li>
                                            สามารถเปลี่ยนแปลงการหักเงินสะสมร้อยละ 
                                            <span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMin) : '' }</span>
                                            และ สูงสุดไม่เกินร้อยละ 
                                            <span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMax) : '' }</span>
                                        </li>
                                        <li>
                                            การเปลี่ยนแปลงเงินสะสมจะมีผลวันที่ {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.providentFundEffectiveDate) : ''} ของทุกปี
                                        </li>
                                    </ol>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col style={{ textAlign:"center"}}>
                                    <Button className="btn-white-red" 
                                        onClick={ async()=>{
                                            await this.setState({
                                                showModalNoteSession:false,
                                                statusForm: false
                                            })
                                    }}>
										ปิด
									</Button>
                                    {
                                        noteModalSession &&
                                        <>
                                            {
                                                ((noteModalSession.status == 'DRAFT' && providentFundRateHistoryIsActiveBtn === true) || 
                                                noteModalSession.status == 'EXPIRED') &&
                                                <>
                                                    <Button 
                                                        className="mx-2 btn-white-red" 
                                                        onClick={async () => await this.setState({
                                                            statusForm: "DRAFT"
                                                        })}
                                                        type="primary" 
                                                        htmlType="submit" 
                                                    >
                                                        บันทึกร่าง
                                                    </Button>
                                                    <Button 
                                                        type="primary" 
                                                        htmlType="submit" 
                                                        className="color-white"
                                                        onClick={async () => await this.setState({
                                                            statusForm: "PENDING"
                                                        })}
                                                    >
                                                        ส่งดำเนินการ
                                                    </Button>
                                                </>
                                            }
                                            {
                                                noteModalSession.status == 'PENDING' &&
                                                <>
                                                    <Button 
                                                        className="mx-2 btn-white-red" 
                                                        onClick={async () => await this.setState({
                                                            statusForm: "CANCEL"
                                                        })}
                                                        type="primary" 
                                                        htmlType="submit" 
                                                    >
                                                        ยกเลิกเอกสาร
                                                    </Button>
                                                </>
                                            }
                                        </>
                                    }
                                </Col>
                            </Row>
                        </Form>
                    }
                    
                </Modal>
                
                <Modal
                    visible={showModalNote}
                    title={"หมายเหตุ"}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <div  dangerouslySetInnerHTML={{ __html: noteModal }} />
                </Modal>

                <ModalForm1 
                    modalCondition1={modalCondition1}
                    hideModalCondition1={this.hideModalCondition1}
                    configDataProvPercentage={ configDataProvPercentage }
                />
                
                <ModalForm2 
                    modalCondition2={modalCondition2}
                    hideModalCondition2={this.hideModalCondition2}
                />
                
                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={12} className="pt-2 mb-3">
                        <strong className="color-red">
                            ข้อมูลกองทุน
                        </strong>
                    </Col>
                    <Col xs={24} md={12} className="mb-3" align="right">
                        {
                            providentFundRateHistoryIsActiveBtn &&
                                <Button type="primary btn-color-default color-white bg-red px-3" htmlType="submit"  onClick={ this.showModalCondition1 }>
                                    เปลี่ยนแปลงการหักอัตราเงินสะสม
                                </Button>
                        }
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'สถานะการเป็นสมาชิก'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.memberStatus || dataForm.employeeFundPolicy.memberStatus == 0 ? dataForm.employeeFundPolicy.memberStatus : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'วันที่เริ่มเป็นสมาชิก'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provStartDate || dataForm.employeeFundPolicy.provStartDate == 0 ? changeFormatdate(dataForm.employeeFundPolicy.provStartDate) : '-'}/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'เงินสะสมในส่วนของสมาชิก ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEmployeeDeduct || dataForm.employeeFundPolicy.provEmployeeDeduct == 0 ? dataForm.employeeFundPolicy.provEmployeeDeduct.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'เงินสะสมในส่วนของสภากาชาดไทย ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEmployerDeduct || dataForm.employeeFundPolicy.provEmployerDeduct == 0 ? dataForm.employeeFundPolicy.provEmployerDeduct.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายการลงทุน'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.fundPolicyName || dataForm.employeeFundPolicy.fundPolicyName == 0 ? dataForm.employeeFundPolicy.fundPolicyName : '-'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายตราสารหนี้ (F) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyFixedRate || dataForm.employeeFundPolicy.policyFixedRate == 0 ? dataForm.employeeFundPolicy.policyFixedRate.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายตราสารทุน (E) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyEquityRate || dataForm.employeeFundPolicy.policyEquityRate == 0 ? dataForm.employeeFundPolicy.policyEquityRate.toFixed(2) : '-' } />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'นโยบายผสม (M) ร้อยละ'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.policyMixRate || dataForm.employeeFundPolicy.policyMixRate == 0 ? dataForm.employeeFundPolicy.policyMixRate.toFixed(2) : '-'} />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} md={12} className="pt-2">
                        <Form.Item label={'เงินสบทบกรณีออกจากกองทุน'} className="mb-0">
                            <Input disabled={true} value={dataForm.employeeFundPolicy.provEndAmount || dataForm.employeeFundPolicy.provEndAmount == 0 ? dataForm.employeeFundPolicy.provEndAmount.toFixed(2) : '-'} />
                        </Form.Item>
                    </Col> */}
                </Row>

                {/* <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={12} className="pt-2 mb-3">
                        <strong className="color-red">
                            ประวัติการเปลี่ยนแปลงข้อมูลการหักเงินสะสม
                        </strong>
                    </Col>
                    <Col xs={24} md={12} className="mb-3" align="right">
                        {
                            dataForm.providentFundRateHistory && 
                                dataForm.providentFundRateHistory.isBtnActive &&
                                <Button type="primary btn-color-default color-white bg-red px-3" htmlType="submit"  onClick={ this.showModalCondition1 }>
                                    เปลี่ยนแปลงการหักเงินสะสม
                                </Button>
                        }
                    </Col>
                    <Col md={24}>
                        <Table
                            locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                            dataSource={dataForm.providentFundRateHistory ? dataForm.providentFundRateHistory.provRateHistory : []} 
                            columns={columnsProvidentFund}
                        />
                    </Col>
                </Row> */}

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={12} className="pt-2 mb-3">
                        <strong className="color-red">
                            ข้อมูลผู้รับผลประโยชน์
                        </strong>
                        <p className="mb-0">
                            ไม่เกินจำนวน 4 คนให้ได้รับส่วนแบ่งรวมทั้งสิ้น 100%
                        </p>
                    </Col>
                    <Col xs={24} md={12} className="mt-3" align="right">
                        {
                            providentFundBenefitsPersonIsActiveBtn &&
                            <>
                                {
                                    dataForm.providentFundBenefitsPerson && dataForm.providentFundBenefitsPerson.isCanEdit ? 
                                        <Link
                                            to={{
                                                pathname: 'benefitsPerson',
                                            }}
                                        >
                                            <Button 
                                                type="primary btn-color-default color-white bg-red px-3" 
                                                htmlType="submit" 
                                            >
                                                
                                                เปลี่ยนแปลงข้อมูลผู้รับผลประโยชน์
                                            </Button>
                                        </Link>
                                    :
                                        <Button type="primary btn-color-default color-white bg-red px-3" htmlType="submit"  onClick={ this.checkStatusprovidentFundBenefitsPerson }>
                                            เปลี่ยนแปลงข้อมูลผู้รับผลประโยชน์
                                        </Button>
                                }
                            </>
                        }
                    </Col>
                    <Col md={24}>
                        <Table
                            locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                            dataSource={dataForm.providentFundBenefitsPerson ?  dataForm.providentFundBenefitsPerson.benefitsPerson : []} 
                            columns={columnsPeopleFund}
                        />
                    </Col>
                </Row>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col xs={24} md={12} className="pt-2 mb-3">
                        <strong className="color-red">
                            การเปลี่ยนแปลงนโยบายการลงทุน
                        </strong>
                    </Col>
                    <Col xs={24} md={12} className="mb-3" align="right">
                        {
                            fundPolicyIsActiveBtn &&
                                <Button type="primary btn-color-default color-white bg-red px-3" htmlType="submit" onClick={ this.showModalConfirmTisco}>
                                    ขอ User เพื่อเข้าใช้งาน Tisco
                                </Button>
                        }
                    </Col>
                    <Col md={24}>
                        <div 
                            className="mt-2 custom-width-tooltip " 
                            dangerouslySetInnerHTML={{ __html: convertToHTMl(dataForm.fundPolicy ? dataForm.fundPolicy.fyi : '') }}
                        /> 
                        {/* <p>
                            บุคลากรสามารถเปลี่ยนแปลงนโยบายกองทุน โดยมีขั้นตอนดังนี้
                        </p>
                        <ol>
                            <li>
                                เข้า Link : www.Tisco.com
                            </li>
                            <li>
                                ทำการประเมินความเสี่ยง ก่อนเปลี่ยนนโยบายการลงทุน
                            </li>
                            <li>
                                เลือกนโยบายการลงทุนที่ต้องการ
                            </li>
                        </ol> */}
                    </Col>
                </Row>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                    <Col md={24}>
                        <Row>
                            <Col>
                                <strong className="color-red">
                                    ประวัติการเปลี่ยนแปลงข้อมูลกองทุนสำรองเลี้ยงชีพ
                                </strong>
                            </Col>
                            <Col className="mt-3">
                                <Table
                                    locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                    dataSource={dataTableSessionHistory} 
                                    columns={columnsSessionHistory}
                                    // loading={preLoadTable}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
		)
	}
}

condition1.defaultProps = {
	autoFocus: false
}

condition1.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const Wrappedcondition1 = Form.create()(condition1)

export default withApollo(Wrappedcondition1)